<script lang="ts">
    import highlightWords from "highlight-words";
    import { get, readable } from "svelte/store";
    import { fade } from "svelte/transition";
    import { LL } from "../../../../i18n/i18n-svelte";
    import { gameManager } from "../../../Phaser/Game/GameManager";
    import { chatSearchBarValue, joignableRoom } from "../../Stores/ChatStore";
    import { selectedRoomStore } from "../../Stores/SelectRoomStore";
    import Avatar from "../Avatar.svelte";
    import { IconLoader } from "@wa-icons";

    interface Props {
        room: { id: string; name: string | undefined };
    }

    let { room }: Props = $props();
    const chat = gameManager.chatConnection;
    let isJoiningRoom = $state(false);
    let joinRoomError: string | undefined = $state(undefined);

    async function joinRoom() {
        try {
            isJoiningRoom = true;
            const newRoom = await chat.joinRoom(room.id);
            joignableRoom.set([]);
            chatSearchBarValue.set("");
            selectedRoomStore.set(newRoom);
        } catch (error) {
            console.error(error);
            if (error instanceof Error) {
                joinRoomError = error.message;
            } else {
                joinRoomError = get(LL).chat.unknownError();
            }
            setTimeout(() => {
                joinRoomError = undefined;
            }, 1000);
        } finally {
            isJoiningRoom = false;
        }
    }

    let chunks = $derived(
        highlightWords({
            text: room.name?.match(/\[\d*]/)
                ? room.name?.substring(0, room.name?.search(/\[\d*]/))
                : room.name
                  ? room.name
                  : "",
            query: $chatSearchBarValue,
        }),
    );
</script>

<div
    class="wa-chat-item text-md flex gap-2 flex-row items-center hover:bg-mdark/10 hover:rounded hover:cursor-pointer! px-2 py-2"
>
    <div class="relative shrink-0">
        <Avatar compact pictureStore={readable(undefined)} fallbackName={room.name} />
    </div>
    <div class="min-w-0">
        {#each chunks as chunk (chunk.key)}
            <span class:text-light-blue={chunk.match} class="cursor-default text-sm font-bold text-mdark/75">
                {chunk.text}
            </span>
        {/each}
    </div>
</div>
{#if !isJoiningRoom}
    <div class="flex">
        <button class="text-blue-300" onclick={() => joinRoom()}>{$LL.chat.join()}</button>
    </div>
{:else}
    <div class="min-h-[30px] text-md flex gap-2 justify-center flex-row items-center p-1">
        <IconLoader class="animate-spin" />
    </div>
{/if}

{#if joinRoomError}
    <div transition:fade class="flex bg-red-500 rounded p-2">{joinRoomError}</div>
{/if}
